import type { IconType } from 'react-icons'
import {
  IoHomeOutline,
  IoHome,
  IoPlayCircleOutline,
  IoPlayCircle,
  IoSearchOutline,
  IoSearch,
  IoHammerOutline,
  IoHammer,
  IoPersonOutline,
  IoPerson,
  IoLockClosedOutline,
  IoLockClosed,
  IoConstructOutline,
  IoConstruct,
  IoNewspaperOutline,
  IoNewspaper,
  IoPeopleOutline,
  IoPeople
} from 'react-icons/io5'
import { GiAmmoBox } from 'react-icons/gi'

export const ICON_BOX = 40
export const ICON_GLYPH = 24

export interface PrimaryNavItem {
  to: string;
  label: string;
  IconActive: IconType;
  IconInactive: IconType;
}

/** Landing page hub (primary rail "Home"). */
export const PRIMARY_HOME_PATH = '/'

/** Slop Feed discover surface. */
export const PRIMARY_SLOP_PATH = '/slop-feed'

/** Primary destinations (bottom bar / sidebar). */
export const PRIMARY_NAV_ITEMS: PrimaryNavItem[] = [
  { to: PRIMARY_HOME_PATH, label: 'Home', IconActive: IoHome, IconInactive: IoHomeOutline },
  { to: PRIMARY_SLOP_PATH, label: 'Slop', IconActive: IoPlayCircle, IconInactive: IoPlayCircleOutline },
  { to: '/registry', label: 'Registry', IconActive: IoSearch, IconInactive: IoSearchOutline },
  { to: '/builds', label: 'Builds', IconActive: IoHammer, IconInactive: IoHammerOutline },
  { to: '/blog', label: 'Blog', IconActive: IoNewspaper, IconInactive: IoNewspaperOutline },
  { to: '/profile', label: 'Profile', IconActive: IoPerson, IconInactive: IoPersonOutline },
  {
    to: '/ammo',
    label: 'Ammo',
    IconActive: GiAmmoBox as IconType,
    IconInactive: GiAmmoBox as IconType
  },
  { to: '/vault', label: 'Vault', IconActive: IoLockClosed, IconInactive: IoLockClosedOutline },
  {
    to: '/parts-bin',
    label: 'Parts',
    IconActive: IoConstruct,
    IconInactive: IoConstructOutline
  },
  {
    to: '/caches',
    label: 'Community',
    IconActive: IoPeople,
    IconInactive: IoPeopleOutline
  }
]

/** Whether this primary tab should show as active for the current URL. */
export function isPrimaryNavActive (
  to: string,
  pathname: string,
  username?: string | null
): boolean {
  if (to === PRIMARY_HOME_PATH) {
    return pathname === PRIMARY_HOME_PATH
  }
  if (to === PRIMARY_SLOP_PATH) {
    return pathname === PRIMARY_SLOP_PATH || pathname.startsWith(`${PRIMARY_SLOP_PATH}/`)
  }
  if (to === '/profile') {
    if (pathname === '/profile') return true
    if (username && pathname === `/profiles/${username}`) return true
    return false
  }
  if (to === '/vault') {
    return pathname === '/vault' || pathname.startsWith('/gun-vault')
  }
  if (to === '/parts-bin') {
    return pathname === '/parts-bin' || pathname.startsWith('/parts/')
  }
  if (to === '/blog') {
    return (
      pathname === '/blog' ||
      pathname.startsWith('/blog/') ||
      pathname === '/createPost' ||
      pathname.startsWith('/manage/')
    )
  }
  if (to === '/caches') {
    return pathname === '/caches' || pathname.startsWith('/caches/') ||
           pathname === '/polls' || pathname.startsWith('/polls/')
  }
  if (to === '/registry' || to === '/builds' || to === '/ammo') {
    return pathname === to || pathname.startsWith(`${to}/`)
  }
  return pathname === to
}
